export default {
  id: 'd66f2a7b9f',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=home><!-- Toolbar--><div class="toolbar toolbar-bottom"><div class=toolbar-inner><div class=col-10></div><a href=javascript:; class="col-20 link button button-fill button-rounded btnLerCodigo p-2"><i class="fas fa-2x fa-qrcode"></i></a> <a href=/codigo/ class="col-20 link button button-fill button-rounded p-2"><i class="fas fa-2x fa-ticket-alt"></i></a> <a href=/leituras/ class="col-20 link button button-fill button-rounded p-2"><i class="fas fa-2x fa-list"></i></a> <a href=/logout/ class="col-20 link button button-fill button-rounded p-2 active"><i class="fas fa-2x fa-sign-out-alt"></i></a><div class=col-10></div></div></div><!-- Scrollable page content--><div class=page-content><div class=block><h3 class=text-align-center>Ao sair, você terá que logar um usuário válido no ADM do Expositor. Não existe a recuperação de senha no APP.</h3><div class=row><div class=col-25></div><a href=/logout/ class="button button-fill button-rounded btnAutenticar col-50" style="font-size: 16px;">SAIR DO APP</a><div class=col-25></div></div></div></div></div>';
      return r;
    }(this);
  },
  styleScoped: false
};